"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var admin_view_instructor_schedule_html_1 = __importDefault(require("./admin-view-instructor-schedule.html"));
var admin_view_instructor_schedule_controller_1 = __importDefault(require("./admin-view-instructor-schedule-controller"));
var telFormat_1 = require("../../../../../common/filters/telFormat");
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state("drivecoach.admin.instructors.view.schedule", {
        url: "/schedule",
        controller: admin_view_instructor_schedule_controller_1.default,
        controllerAs: "vm",
        template: admin_view_instructor_schedule_html_1.default,
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.administrator,
                USER_ROLES.owner,
            ],
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];
exports.default = angular_1.default
    .module("admin.dashboard.instructors.view.schedule", [])
    .config(config)
    .controller("AdminInstructorsViewScheduleController", admin_view_instructor_schedule_controller_1.default)
    .filter("telFormat", telFormat_1.telFormat);
